import React, { useEffect, useState } from 'react';
import { Button } from './Button';
interface NavigationProps {
  onApplyClick: () => void;
}
export function Navigation({
  onApplyClick
}: NavigationProps) {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <nav className="fixed top-0 w-full z-50 transition-all duration-300" style={{
    backgroundColor: `rgba(5, 8, 20, ${isScrolled ? 0.92 : 0})`,
    backdropFilter: `blur(${isScrolled ? 20 : 0}px)`,
    borderBottom: `1px solid ${isScrolled ? 'rgba(30, 41, 59, 0.3)' : 'transparent'}`
  }} data-id="element-221">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between" data-id="element-222">
        <div className="text-xl font-bold text-white cursor-pointer" onClick={() => window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })} data-id="element-223">
          Pulsewave
        </div>

        <Button variant="primary" className="!py-2 !px-5 text-sm" onClick={onApplyClick} data-id="element-224">
          Apply
        </Button>
      </div>
    </nav>;
}